<button type="button"
  class="btn trend-button btn-primary fw-bold w-100 mdi mdi-refresh dropdown-toggle"
  [matMenuTriggerFor]="refreshMenu"
  [matTooltip]="'campaign.refreshInterval.label' | translate">
  {{ currentOption.labelKey | translate }}
</button>
<mat-menu #refreshMenu="matMenu">
  @for (option of options; track option.ms) {
    <button mat-menu-item type="button" (click)="choose(option.ms)">
      {{ option.labelKey | translate }}
    </button>
  }
</mat-menu>
